export const projectData = {
    uffici: {
        titleKey: "catOffices",
        subtitleKey: "catOfficesSub",
        coverImage: "./assets/Progetti/Uffici Confai BG.jpg",
        images: [
            { src: "./assets/Progetti/Uffici Confai BG.jpg", alt: "Uffici Confai, Bergamo" },
            { src: "./assets/Progetti/Uffici Studio Vassalli 01.jpg", alt: "Uffici Studio Vassalli, Brescia" },
            { src: "./assets/Progetti/Uffici Studio Vassalli 02.jpg", alt: "Uffici Studio Vassalli, Brescia" },
        ]
    },
    negozi: {
        titleKey: "catRetail",
        subtitleKey: "catRetailSub",
        coverImage: "./assets/Progetti/Centro Commerciale Merlata Bloom 01.jpg",
        images: [
            { src: "./assets/Progetti/Centro Commerciale Merlata Bloom 01.jpg", alt: "Merlata Bloom Milano" },
            { src: "./assets/Progetti/Centro Commerciale Merlata Bloom 02.jpg", alt: "Merlata Bloom Milano" },
            { src: "./assets/Progetti/Piazza Portello 01.jpg", alt: "Piazza Portello, Milano" },
            { src: "./assets/Progetti/Piazza Portello 02.jpg", alt: "Piazza Portello, Milano" },
            { src: "./assets/Progetti/Piazza Portello 03.jpg", alt: "Piazza Portello, Milano" },
        ]
    },
    "spazi-esterni": {
        titleKey: "catOutdoor",
        subtitleKey: "catOutdoorSub",
        coverImage: "./assets/Progetti/Lago Iseo 01.jpg",
        images: [
            { src: "./assets/Progetti/Lago Iseo 01.jpg", alt: "Lago D'iseo" },
            { src: "./assets/Progetti/Lago Iseo 02.jpg", alt: "Lago D'iseo" },
            { src: "./assets/Progetti/Lago Iseo 03.jpg", alt: "Lago D'iseo" },
            { src: "./assets/Progetti/Lungolago Iseo 01.jpg", alt: "Lungolago D'iseo" },
            { src: "./assets/Progetti/Lungolago Iseo 02.jpg", alt: "Lungolago D'iseo" },
            { src: "./assets/Progetti/Lungolago Iseo 03.jpg", alt: "Lungolago D'iseo" },
            { src: "./assets/Progetti/Lago Maggiore 01.jpg", alt: "Lago Maggiore, Lesa" },
            { src: "./assets/Progetti/Lago Maggiore 02.jpg", alt: "Lago Maggiore, Lesa" },
            { src: "./assets/Progetti/Lesa 01.jpg", alt: "Lesa, Novara" },
            { src: "./assets/Progetti/Menzino 01.jpg", alt: "Menzino, Monte Isola" },
            { src: "./assets/Progetti/Menzino 03.jpg", alt: "Menzino, Monte Isola" },
            { src: "./assets/Progetti/Menzino 04.jpg", alt: "Menzino, Monte Isola" },
            { src: "./assets/Progetti/Menzino 05.jpg", alt: "Menzino, Monte Isola" },
            { src: "./assets/Progetti/Ponte Sospeso 01.jpg", alt: "Ponte Sospeso, Clanezzo" },
            { src: "./assets/Progetti/Ponte Sospeso 02.jpg", alt: "Ponte Sospeso, Clanezzo" },
            { src: "./assets/Progetti/Ponte Sospeso 03.jpg", alt: "Ponte Sospeso, Clanezzo" },
            { src: "./assets/Progetti/Palazzo Castiglioni 01.jpg", alt: "Palazzo Castiglioni, Milano" },
            { src: "./assets/Progetti/Palazzo Castiglioni 02.jpg", alt: "Palazzo Castiglioni, Milano" },
            { src: "./assets/Progetti/Palazzo Castiglioni 03.jpg", alt: "Palazzo Castiglioni, Milano" },
            { src: "./assets/Progetti/Jesolo 01.jpg", alt: "Jesolo" },
            { src: "./assets/Progetti/Jesolo 02.jpg", alt: "Jesolo" },
            { src: "./assets/Progetti/Jesolo 03.jpg", alt: "Jesolo" },
        ]
    },
    "chiese-musei": {
        titleKey: "catInteriors",
        subtitleKey: "catInteriorsSub",
        coverImage: "./assets/Progetti/Chiesa San Luca 01.jpg",
        images: [
            { src: "./assets/Progetti/Chiesa San Luca 01.jpg", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa San Luca 02.jpg", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa San Luca 03.jpg", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa San Luca 04.jpg", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa San Luca 05.jpg", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa San Luca 06.jpg", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 01.jpg", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 02.jpg", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 03.jpg", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 04.jpg", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 05.jpg", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 06.jpg", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 07.jpg", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
            { src: "./assets/Progetti/Basilica di San Martino 01.jpg", alt: "Basilica di San Martino, Treviglio" },
            { src: "./assets/Progetti/Basilica di San Martino 02.jpg", alt: "Basilica di San Martino, Treviglio" },
            { src: "./assets/Progetti/Basilica di San Martino 03.jpg", alt: "Basilica di San Martino, Treviglio" },
            { src: "./assets/Progetti/Basilica di San Martino 04.jpg", alt: "Basilica di San Martino, Treviglio" },
            { src: "./assets/Progetti/Basilica di San Martino 05.jpg", alt: "Basilica di San Martino, Treviglio" },
        ]
    },
    industria: {
        titleKey: "catIndustry",
        subtitleKey: "catIndustrySub",
        coverImage: "./assets/Progetti/Logistica Coop 01.jpg",
        images: [
            { src: "./assets/Progetti/Logistica Coop 01.jpg", alt: "Logistica Coop, Pieve Emanuele" },
            { src: "./assets/Progetti/Logistica Coop 02.jpg", alt: "Logistica Coop, Pieve Emanuele" },
        ]
    },
    "residenze-hospitality": {
        titleKey: "catResidence",
        subtitleKey: "catResidenceSub",
        coverImage: "./assets/Progetti/Palazzo Bovara 01.jpg",
        images: [
            { src: "./assets/Progetti/Palazzo Bovara 01.jpg", alt: "Palazzo Bovara, Milano" },
            { src: "./assets/Progetti/Palazzo Bovara 02.jpg", alt: "Palazzo Bovara, Milano" },
            { src: "./assets/Progetti/Palazzo Bovara 03.jpg", alt: "Palazzo Bovara, Milano" },
            { src: "./assets/Progetti/Palazzo Bovara 04.jpg", alt: "Palazzo Bovara, Milano" },
        ]
    }
};